const viewUtils = {
  isElementInViewport(element: HTMLDivElement | null, offset = 0): boolean {
    if (!element) {
      return false;
    }

    const top = element.getBoundingClientRect().top;
    return top + offset >= 0 && top - offset <= window.innerHeight;
  },
};

export default viewUtils;
